<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="locate-btn-view">
    <button class="locate-btn" @click="getCurrentLocation"></button>
  </div>
</template>

<script>
  import Notifications from '../../utils/Notifications'

  export default {
    name: 'LocateButton',
    methods: {
      isiOS () {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
      },
      getCurrentLocation() {
        try {
            navigator.geolocation.getCurrentPosition((position) => {
              this.$store.dispatch('setMapCenter', {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              })
            }, () => {
              Notifications.alert('현재 위치를 검색할 수 없습니다.\n지하, 실내 및 기타 GPS를 이용하기 어려운 환경이신 경우 원활한 환경에서 다시 시도해 주시기 바랍니다.')
            })
          } catch (error) {
            Notifications.alert('현재 위치를 검색할 수 없습니다.\n지하, 실내 및 기타 GPS를 이용하기 어려운 환경이신 경우 원활한 환경에서 다시 시도해 주시기 바랍니다.')
          }

        // if (this.$store.state.APP.IS_NATIVE && this.isiOS()) {
        //   window.open('IOS://CALL_GEOLOCATION')
        // } else if (navigator.geolocation) {
        //   try {
        //     navigator.geolocation.getCurrentPosition((position) => {
        //       this.$store.dispatch('setMapCenter', {
        //         latitude: position.coords.latitude,
        //         longitude: position.coords.longitude
        //       })
        //     }, () => {
        //       Notifications.alert('현재 위치를 검색할 수 없습니다.\n지하, 실내 및 기타 GPS를 이용하기 어려운 환경이신 경우 원활한 환경에서 다시 시도 해 주시기 바랍니다.')
        //     })
        //   } catch (error) {
        //     Notifications.alert('현재 위치를 검색할 수 없습니다.\n지하, 실내 및 기타 GPS를 이용하기 어려운 환경이신 경우 원활한 환경에서 다시 시도 해 주시기 바랍니다.')
        //   }
        // }
      }
    },
    mounted () {
      window.getCurrentLocationDataByiOS = (latitude, longitude) => {
        this.$store.dispatch('setMapCenter', {
          latitude: latitude,
          longitude: longitude
        })
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .locate-btn-view {
    z-index: 1;
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 3.75rem;
    height: 3.75rem;
    background: white;
    line-height: 3.75rem;
    border-radius: 1rem;
    border: 1px solid @windows-blue;
    text-align: center;

    button {
      vertical-align: middle;
      background-image: url('../../assets/images/locate-on@3x.png');
      background-repeat: no-repeat no-repeat;
      background-size: contain;
      width: 2.5rem;
      height: 2.5rem;
      background-color: transparent;
      padding: 0;
    }
  }

</style>
